// src/components/blogs/Blogs.jsx
import React, { useMemo } from 'react'
import { PageTitle } from '../../_metronic/layout/core'
import { KTSVG } from '../../_metronic/helpers'
import BlogSearchAndFilters from '../modules/blog/BlogSearchAndFilters'
import BlogList from '../modules/blog/BlogList'
import BlogPagination from '../modules/blog/BlogPagination'
import BlogForm from '../modules/blog/BlogForm'
import { useBlogs } from '../modules/blog/useBlog'

const Blogs = () => {
    const {
        //States
        sortBy,
        searchQuery,
        allData,
        pageCount,
        totalItems,
        lgshow,
        blogTitle,
        blogDescription,
        blogMetaTitle,
        blogMetaKeywords,
        blogMetaDescription,
        blogStatus,
        quillValue,
        fileFormatErrorThumbnail,
        isEditThumbnail,
        fileSizeErrorThumbnail,
        thumbnail_selected,
        modalTitle,
        viewMode,
        quillRef,
        calenderDates,
        slug,
        thumbNailAlt,

        // Handlers
        setSlug,
        setThumbNailAlt,
        setSortBy,
        setSearchQuery,
        handlePageClick,
        viewDetails,
        handleThumbnail,
        handleShow,
        handleClose,
        handleBlogForm,
        imageHandler,
        editBlog,
        deleteBlog,
        changeDataRange,
        setBlogTitle,
        setBlogDescription,
        setBlogMetaTitle,
        setBlogMetaKeywords,
        setBlogMetaDescription,
        setBlogStatus,
        setQuillValue,
    } = useBlogs()

    const modules = useMemo(
        () => ({
            toolbar: {
                container: [
                    [{ header: [1, 2, 3, 4, 5, 6, false] }],
                    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                    [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
                    [{ color: [] }, { background: [] }],
                    [{ font: [] }],
                    [{ align: [] }],
                    ['link', 'image'],
                    ['clean'],
                ],
                handlers: { image: imageHandler },
            },
        }),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [],
    )

    const formats = [
        'header',
        'bold',
        'italic',
        'underline',
        'strike',
        'blockquote',
        'list',
        'bullet',
        'indent',
        'color',
        'background',
        'font',
        'align',
        'link',
        'image',
    ]
    return (
        <>
            <PageTitle breadcrumbs={[]}>Manage Blogs</PageTitle>
            <div className={`card card-light`}>
                <div className="card-header border-0 pt-5">
                    <h3 className="card-title align-items-start flex-column">
                        <span className="card-label fw-bold fs-3 mb-1">
                            Total Blogs{' '}
                            <span className="p-1 mt-1 fw-semibold fs-7 bg-primary text-white rounded">
                                {totalItems < 10 ? '0' + totalItems : totalItems}
                            </span>
                        </span>
                    </h3>
                    <div
                        className="card-toolbar"
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        data-bs-trigger="hover"
                        title="Click to add a user"
                    >
                        <button
                            onClick={(e) => handleShow(e, 'Upload New Blog', 'Upload New Blog')}
                            className="btn btn-sm btn-light-primary"
                            // data-bs-toggle="modal"
                            // data-bs-target="#category_modal"
                        >
                            <KTSVG path="media/icons/duotune/arrows/arr075.svg" className="svg-icon-3 " />
                            New Blog
                        </button>
                    </div>
                </div>

                <BlogSearchAndFilters
                    searchQuery={searchQuery}
                    setSearchQuery={setSearchQuery}
                    sortBy={sortBy}
                    setSortBy={setSortBy}
                    calenderDates={calenderDates}
                    changeDataRange={changeDataRange}
                />

                <div className="card-body py-3">
                    <BlogList allData={allData} viewDetails={viewDetails} editBlog={editBlog} deleteBlog={deleteBlog} />
                    <BlogPagination pageCount={pageCount} handlePageClick={handlePageClick} />
                </div>
            </div>

            <BlogForm
                lgshow={lgshow}
                handleClose={handleClose}
                modalTitle={modalTitle}
                viewMode={viewMode}
                blogTitle={blogTitle}
                setBlogTitle={setBlogTitle}
                blogMetaTitle={blogMetaTitle}
                setBlogMetaTitle={setBlogMetaTitle}
                blogMetaKeywords={blogMetaKeywords}
                setBlogMetaKeywords={setBlogMetaKeywords}
                blogMetaDescription={blogMetaDescription}
                setBlogMetaDescription={setBlogMetaDescription}
                blogStatus={blogStatus}
                setBlogStatus={setBlogStatus}
                quillValue={quillValue}
                setQuillValue={setQuillValue}
                fileFormatErrorThumbnail={fileFormatErrorThumbnail}
                fileSizeErrorThumbnail={fileSizeErrorThumbnail}
                handleThumbnail={handleThumbnail}
                isEditThumbnail={isEditThumbnail}
                thumbnail_selected={thumbnail_selected}
                blogDescription={blogDescription}
                setBlogDescription={setBlogDescription}
                handleBlogForm={handleBlogForm}
                modules={modules}
                quillRef={quillRef}
                formats={formats}
                slug={slug}
                setSlug={setSlug}
                thumbNailAlt={thumbNailAlt}
                setThumbNailAlt={setThumbNailAlt}
            />
        </>
    )
}

export default Blogs
